export default __webpack_public_path__ + "static/media/chase.c8c2541c.svg";